import React, { Component } from "react";
import * as Sentry from "@sentry/browser";

import firebase from "firebaseFactory";

type ErrorBoundaryProps = {};
type ErrorBoundaryState = {
  readonly error: Error | null | undefined;
  readonly eventId: string | undefined;
};

export default class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  readonly state: ErrorBoundaryState = {
    error: undefined,
    eventId: undefined,
  };

  componentDidCatch(error: Error | null, info: object) {
    this.setState({ error });
    Sentry.withScope((scope) => {
      scope.setExtras(info);
      scope.setUser({ id: firebase.auth().currentUser?.uid });
      const eventId = Sentry.captureException(error);
      this.setState({ eventId });
    });
  }

  render() {
    const { error, eventId } = this.state;
    const { children } = this.props;
    if (error) {
      return (
        <p>
          Sorry, an unexpected problem occured. Please quote Sentry eventId{" "}
          {eventId}.
        </p>
      );
    }
    return children;
  }
}
